import { useEffect } from 'react';

const BASE_TITLE = 'Messages — Tizok';

/**
 * Sets `document.title` for the duration of the calling component's mount.
 * Restores the previous title (`BASE_TITLE` if none) on unmount so SPA
 * navigation doesn't leave a stale title behind.
 *
 * Per WCAG 2.4.2 (Page Titled) — title is the first thing announced by
 * most screen readers on route change.
 */
export function useDocumentTitle(suffix: string | null): void {
  useEffect(() => {
    const previous = document.title;
    const next = suffix ? `${suffix} — Tizok` : BASE_TITLE;
    document.title = next;
    return () => {
      if (document.title === next) {
        document.title = previous;
      }
    };
  }, [suffix]);
}
